var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderWidthSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.625C0 2.52554 0.0395088 2.43016 0.109835 2.35984C0.180161 2.28951 0.275544 2.25 0.375 2.25H11.625C11.7245 2.25 11.8198 2.28951 11.8902 2.35984C11.9605 2.43016 12 2.52554 12 2.625V4.125C12 4.22446 11.9605 4.31984 11.8902 4.39016C11.8198 4.46049 11.7245 4.5 11.625 4.5H0.375C0.275544 4.5 0.180161 4.46049 0.109835 4.39016C0.0395088 4.31984 0 4.22446 0 4.125V2.625ZM0 6.375C0 6.27554 0.0395088 6.18016 0.109835 6.10983C0.180161 6.03951 0.275544 6 0.375 6H11.625C11.7245 6 11.8198 6.03951 11.8902 6.10983C11.9605 6.18016 12 6.27554 12 6.375V7.125C12 7.22446 11.9605 7.31984 11.8902 7.39017C11.8198 7.46049 11.7245 7.5 11.625 7.5H0.375C0.275544 7.5 0.180161 7.46049 0.109835 7.39017C0.0395088 7.31984 0 7.22446 0 7.125V6.375ZM0 9.375C0 9.27554 0.0395088 9.18016 0.109835 9.10983C0.180161 9.03951 0.275544 9 0.375 9H11.625C11.7245 9 11.8198 9.03951 11.8902 9.10983C11.9605 9.18016 12 9.27554 12 9.375C12 9.47446 11.9605 9.56984 11.8902 9.64017C11.8198 9.71049 11.7245 9.75 11.625 9.75H0.375C0.275544 9.75 0.180161 9.71049 0.109835 9.64017C0.0395088 9.56984 0 9.47446 0 9.375Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderWidthSmall);
export default __webpack_public_path__ + "static/media/border-width-small.b5e54e9b35cc740dd563bf0d0f987da6.svg";
export { ForwardRef as ReactComponent };